import { invalidLength, notAlphanumeric, isDuplicate } from 'utils/vins'

export const VIN_ERROR_MESSAGES = {
  invalidLength: 'VIN must be 4 to 6 characters long.',
  notAlphanumeric: 'VIN must be alphanumeric.',
  isDuplicate: 'Vin must be unique.',
}

export const VALID_CRITERIA = {
  invalidLength,
  notAlphanumeric,
  isDuplicate,
}
